__turbopack_context__.v({
  "collapsed": "choose-module__GiBGaq__collapsed",
  "expanded": "choose-module__GiBGaq__expanded",
  "hide": "choose-module__GiBGaq__hide",
  "hover-card": "choose-module__GiBGaq__hover-card",
  "iconimg": "choose-module__GiBGaq__iconimg",
  "read-more": "choose-module__GiBGaq__read-more",
  "readmore": "choose-module__GiBGaq__readmore",
  "roadmapFirst": "choose-module__GiBGaq__roadmapFirst",
  "roadmapSecond": "choose-module__GiBGaq__roadmapSecond",
  "sectiontitle": "choose-module__GiBGaq__sectiontitle",
  "standard": "choose-module__GiBGaq__standard",
  "text-primary": "choose-module__GiBGaq__text-primary",
  "viewcontent": "choose-module__GiBGaq__viewcontent",
});
